/**
 * 保存菜单及操作权限
 */

const state = {
  menus: [],
  operations: new Map(),
  menuUrlMap: new Map()
}

const mutations = {
  SET_PERMISSION: (state, data) => {
    if (data.menus && data.menus instanceof Array) {
      state.menus = data.menus
      // 遍历树，得到url的map，用于router时验证
      let tree = {
        children: data.menus
      }
      let stack = []
      stack.push(tree)
      while (stack.length !== 0) {
        let item = stack.pop()
        if (item.url && item.url !== '') {
          state.menuUrlMap.set(item.url, item)
        }
        if (item.children) {
          for (let i = 0; i < item.children.length; i++) {
            stack.push(item.children[i])
          }
        }
      }
    } else {
      state.menuUrlMap.clear()
      state.menus = []
    }
    
    state.operations.clear()
    const operations = data.operations
    if (operations && operations instanceof Array) {
      for (let i = 0; i < operations.length; i++) {
        let buttonCodes = operations[i].buttonCodes
        let buttonCodeSet
        if (buttonCodes && buttonCodes instanceof Array) {
          buttonCodeSet = new Set(buttonCodes)
        } else {
          buttonCodeSet = new Set()
        }
        state.operations.set(operations[i].menuCode, buttonCodeSet)
      }
    }
  },
  CLEAR_PERMISSION: (state) => {
    state.menus = []
    state.operations.clear()
    state.menuUrlMap.clear()
  }
}

const actions = {
  setPermission({commit}, data) {
    return new Promise(resolve => {
      commit('SET_PERMISSION', data)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
